import { render, staticRenderFns } from "./timezones.vue?vue&type=template&id=1ca10d1c"
import script from "./timezones.vue?vue&type=script&lang=js"
export * from "./timezones.vue?vue&type=script&lang=js"
import style0 from "./timezones.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/basement/timezones.vue
// module id = 4Wjw
// module chunks = 0